




import {Component, Prop, Vue} from "vue-property-decorator";

@Component
export default class SelfUpdatingTimeDiff extends Vue {
  public name: string = "SelfUpdatingTimeDiff";

  @Prop({required: true})
  public time!: string;

  private mTime: string = '';

  created() {

    setInterval(() => {

      this.mTime = this.$moment(this.time).from();
    }, 1000);

  }


}
